import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from "@angular/core";
import { BehaviorSubject, Subscription } from "rxjs";
import { DataService } from "../../../@core/services/data.service";
import { FooterInterface } from "../../../@core/models/site-material-data.model";
import { SocialNetworksModel } from "../../../@core/models/social-networks.model";
import { MenuItemModel } from "../../../@core/models/site-data.model";

@Component({
  selector: "app-material-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaterialFooterComponent implements OnInit, OnDestroy {
  socialNetworks: SocialNetworksModel = {};
  // siteMenu: MenuItemModel[] = [];
  siteMenu$: BehaviorSubject<MenuItemModel[]> = new BehaviorSubject<MenuItemModel[]>([]);
  subscription: Subscription;
  textColor: string;
  backgroundColor: string;
  activatePadding: boolean = false;
  data: FooterInterface;
  active: boolean = false;
  siteUrl: string = "";
  siteName: string = "";
  termsofService: string = "";
  privacyPolicy: string = "";
  fullWidth: boolean = false;
  year = new Date().getFullYear();
  constructor(
    private dataService: DataService
  ) { }

  ngOnInit() {
    // this.socialNetworks = this.data.socialNetworks;
    this.subscription = this.dataService.getCurrentSite().subscribe((site) => {
      if (site) {
        if (!this.data && site.siteData) {
          this.data =
            typeof site.siteData == "string"
              ? JSON.parse(site.siteData)["Footer"]
              : site.siteData["Footer"];
        }
        this.siteName = site.siteName;
        this.termsofService = site.termsofService;
        this.privacyPolicy = site.privacyPolicy;
        if (site.siteMenu) {
          const result = site.siteMenu.map((element) => {
            return { ...element, newUrl: element.title.replace(/ /g, "-") };
          });
          this.siteMenu$.next(result);
        }
        this.backgroundColor =
          this.data && this.data.backgroundColor
            ? this.data.backgroundColor
            : site && site.siteMenu && site.siteMenu.length > 0
              ? site.siteMenu[0].backgroundColor
              : "";
        this.textColor =
          this.data && this.data.textColor
            ? this.data.textColor
            : site && site.siteMenu && site.siteMenu.length > 0
              ? site.siteMenu[0].textColor
              : "";
        this.siteUrl = site.domainName ? (site.domainName.split('.').length > 2 ? site.domainName : 'www.' + site.domainName) : site.siteUrl;
        if (site && site.socialMedia) {
          site.socialMedia.forEach((element) => {
            if (element.link) {
              this.socialNetworks[element.network] = element.link;
            }
          });
        }
        if (
          !this.socialNetworks.facebook &&
          !this.socialNetworks.twitter &&
          !this.socialNetworks.instagram &&
          !this.socialNetworks.youtube &&
          !this.socialNetworks.pinterest &&
          !this.socialNetworks.vkontakte &&
          !this.socialNetworks.linkedin &&
          !this.socialNetworks.snapchat
        ) {
          this.fullWidth = true;
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  navigateTo(fragment: string) {
    if (fragment) {
      fragment = fragment.replace("/#", "");
      setTimeout(() => {
        if (document.getElementById(fragment)) {
          document
            .getElementById(fragment)
            .scrollIntoView({ behavior: "smooth" });
        }
      });
    }
  }
}
